module.exports = __webpack_public_path__ + "static/img/month_3rd_prize.9940693.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize/month_3rd_prize.png
// module id = 9sZT
// module chunks = 1